import Map, { Marker } from 'react-map-gl';
import { RootState, useAppSelector } from '../../redux/AppStore';

export default function MapComponent() {
  const updatedAddress = useAppSelector((state: RootState) => state.updateAddress.newuserData);
  console.log(updatedAddress.shipment_longitude);
  return (
    <div className="right_Section">
    <Map
      mapboxAccessToken="pk.eyJ1IjoiaW5zdGFkaXNwYXRjaCIsImEiOiJjazJvajJueWwwNjlmM2dwcHMxbTFiMHl0In0.9eyVqMCN3WIodGdslgQ1hA"
      initialViewState={{
        longitude: Number(updatedAddress.shipment_longitude ?? 0),
        latitude: Number(updatedAddress.shipment_latitude ?? 0),
        zoom: 3
      }}
      style={{ width: 650, height: 450 }}
      mapStyle="mapbox://styles/mapbox/streets-v9"
      attributionControl={false}   
      >
      <Marker longitude={Number(updatedAddress.shipment_longitude)} latitude={Number(updatedAddress.shipment_latitude)}>
      </Marker>
    </Map>
    </div>
  );
}
